<template>
  <div class="map-container">
    <div class="platFormIntroduceBtn" @click="detailShowSwitch">平台简介</div>
    <transition name="el-zoom-in-center">
      <div class="platFormIntroduceDetail" v-if="showDetail">
        <span class="closeBtn el-icon-close" @click="closePdfView"></span>
        <iframe
          :src="pdfUrl + '#scrollbars=0&toolbar=0&statusbar=0&view=FitH,top'"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </transition>
    <div class="top">
      <div>
        <div>
          <img draggable="false" src="/static/img/device.png" alt="" />
          <div class="count count-1">
            <span>{{ countData.deviceCount }}</span>
            <span>监测设备数</span>
          </div>
        </div>
      </div>
      <div>
        <div>
          <img draggable="false" src="/static/img/fault.png" alt="" />
          <div class="count count-2">
            <span>{{ countData.faultCount }}</span>
            <span>设备故障数</span>
          </div>
        </div>
      </div>
      <div>
        <div>
          <img draggable="false" src="/static/img/alarm.png" alt="" />
          <div class="count count-3">
            <span>{{ countData.alarmCount }}</span>
            <span>累计报警次数</span>
          </div>
        </div>
      </div>
      <div>
        <div>
          <img draggable="false" src="/static/img/nomal.png" alt="" />
          <div class="count count-4">
            <span>{{ countData.recoverCount }}</span>
            <span>累计恢复次数</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg">
      <img draggable="false" src="/static/img/bg.png" alt="" />
      <span
        >监测站点: <span>{{ siteData.length || 0 }}</span></span
      >
    </div>
    <div class="map">
      <!-- <div id="id-map"></div> -->
      <dv-flyline-chart-enhanced
        v-if="flyline"
        :config="ChinaMapConfig"
        style="width:100%;height:100%;"
      />
    </div>
    <div class="white"></div>
    <div class="floor">
      <div class="left">
        <div class="title">
          <img src="/static/img/title.png" alt="" />
          <span>站点信息</span>
        </div>
        <div class="main-list">
          <div class="main-list--head">
            <span
              v-for="item in region"
              :key="item.name"
              :class="item.name === activeName && 'active-tab'"
              class="tab"
              @click="tabClick(item.name)"
              >{{ item.name }} ({{ item.value }})</span
            >
          </div>
          <div class="line"></div>
          <div class="main-list-body">
            <SiteItem
              v-for="item in siteData"
              :data="item"
              :key="item.createTime"
              @click="clickMarker"
            />
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">
          <img src="/static/img/title.png" alt="" />
          <span>报警消息</span>
        </div>
        <div class="main-list">
          <div class="main-list--head">
            <img draggable="false" src="/static/img/alarm_icon.png" alt="" />
            <span
              >最新<span>{{ alarmData.length || 0 }}</span
              >条</span
            >
          </div>
          <div class="line"></div>
          <div class="main-list-body">
            <DataItem
              v-for="(item, index) in alarmData"
              :data="item"
              :key="index"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="show" class="dialog">
      <div class="title">{{ markerName }}</div>
      <i @click="dialogCloseClick" class="close el-icon-close"></i>
      <Legend :data="detailData" />
    </div>
  </div>
</template>

<script>
import DataItem from "./DataItem";
import SiteItem from "./SiteItem";
import Legend from "./Legend";

import {
  summary,
  getAlarmData,
  getTerminalData,
  statusDetail,
  getRegions
} from "./service";

export default {
  name: "MapMode",
  components: {
    DataItem,
    SiteItem,
    Legend
  },

  data() {
    return {
      flyline: false,
      showDetail: false,
      pdfUrl: "https://bigdata-v.prod.hndfsj.net/yjyw.pdf",
      ChinaMapConfig: {
        bgImgSrc: "/static/img/layout/map-China.png",
        points: [],
        lines: [
          {
            radius: 60,
            width: 2,
            source: "",
            target: ""
          }
        ],
        icon: {
          show: true,
          src: "/static/img/layout/mapPoint.png"
        },
        text: {
          show: true
        }
      },
      countData: {},
      alarmData: {},
      siteData: [],
      map: null,
      AMap: null,
      interval: null,
      detailData: null,
      show: false,
      markerName: "",
      region: [],
      activeName: ""
    };
  },

  methods: {
    detailShowSwitch() {
      this.showDetail = !this.showDetail;
    },

    closePdfView() {
      this.showDetail = false;
    },
    tabClick(name) {
      this.activeName = name;
      this.siteData = [];
      this.getTerminal(name);
    },
    // 地图扎点
    doMarker({ map, AMap, data }) {
      const icon = normal =>
        new AMap.Icon({
          size: new AMap.Size(74, 67),
          image: `/static/img/marker_${normal ? "blue" : "red"}.png`,
          imageSize: new AMap.Size(74, 67)
        });

      let markerList = (data || [])
        .filter(e => e.id && e.latitude && e.longitude)
        .map(e => {
          let marker = new AMap.Marker({
            position: [e.longitude, e.latitude],
            icon: icon(e.totalStatus === 1),
            offset: new AMap.Pixel(-13, -30),
            clickable: true,
            extData: {
              id: e.id,
              name: e.name
            }
          });
          // 监听marker click
          AMap.event.addListener(marker, "click", e => {
            if (!this.show) {
              try {
                let { id, name } = e.target.getExtData();
                this.markerName = name;
                this.clickMarker(id);
              } catch (err) {
                console.log(err);
              }
            }
          });
          return marker;
        });
      if (markerList.length > 0) {
        map.add([...markerList]);
      }
    },
    dialogCloseClick() {
      this.detailData = null;
      this.show = false;
    },

    // 扎点点击
    clickMarker(name, id) {
      this.markerName = name;
      this.show = false
      statusDetail(id).then(res => {
        this.show = true;
        this.detailData = res.data;
      });
    },
    getSummary() {
      summary().then(res => {
        this.countData = res.data || {};
      });
    },
    getAlarm() {
      getAlarmData().then(res => {
        this.alarmData = res.data.list || [];
      });
    },
    getTerminal(name) {
      this.flyline = false;
      getTerminalData(name)
        .then(res => {
          this.siteData = res.data.list || [];
          let points = this.siteData.map(e => {
            return {
              name: "",
              coordinate: [e.x, e.y],
              icon: {
                src: "/static/img/layout/mapCenterPoint.png",
                width: 30,
                height: 30
              },
              halo: {
                show: true
              },
              text: {
                color: "#00ffee"
              }
            };
          });
          this.ChinaMapConfig.points = points;
        })
        .finally(() => {
          this.flyline = true;
        });
    },

    getData() {
      this.getSummary();
      this.getAlarm();
      this.getTerminal(this.activeName);
    }
  },

  created() {
    getRegions().then(res => {
      let list = (res.data.list || []).map(e => {
        let keys = Object.keys(e);
        let key = "";
        let value = "";
        if (keys.length > 0) {
          key = keys[0];
          value = e[key];
        }
        if (key) {
          return { name: key, value };
        }
      });
      let data = list.filter(e => e);
      let index = data.findIndex(e => e.name === "全部");
      let newList = data.filter(e => e.name !== "全部");
      if (index !== -1) {
        let first = data[index];
        newList.unshift(first);
        this.activeName = first.name;
      } else {
        this.activeName = newList[0] ? newList[0].name : "";
      }
      this.region = newList;
    });
  },

  mounted() {
    this.getData();
  },

  beforeUnmount() {}
};
</script>
<style scoped lang="less">
.platFormIntroduceBtn {
  display: inline-block;
  width: 132px;
  height: 70px;
  background: url("/static/img/layout/platformIntroduceBg.png");
  background-size: 100% 100%;
  position: absolute;
  top: 300px;
  left: 0;
  text-align: center;
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  line-height: 70px;
}
.platFormIntroduceDetail {
  width: 800px;
  height: 900px;
  padding-top: 30px;
  overflow-y: scroll;
  // background: url('/static/img/layout/platformIntroduceDetailBg.png');
  // background-size: 100% 100%;
  position: absolute;
  top: 150px;
  left: 130px;
  color: #d7fdff;
  font-size: 18px;
  line-height: 24px;
  z-index: 10000;
  .closeBtn {
    display: inline-blockl;
    width: 20px;
    height: 20px;
    cursor: pointer;
    font-size: 30px;
    position: absolute;
    right: 5px;
    top: 0;
    z-index: 10000000;
  }
  iframe {
    width: 100%;
    height: calc(100% - 20px);
    border-radius: 10px;
    ::-webkit-scrollbar-thumb {
      cursor: pointer;
      box-shadow: inset 0 0 6px #106669;
      background-color: #05dbe3;
      border-radius: 4px;
    }

    ::-webkit-scrollbar:hover {
      width: 5px;
      height: 10px;
    }

    ::-webkit-scrollbar-corner {
      background-color: #181f27;
    }
  }
}
.bg {
  width: 775px;
  margin: 0 auto;
  position: relative;
  img {
    width: 775px;
  }
  > span {
    position: absolute;
    top: 33%;
    left: 50%;
    font-size: 20px;
    color: #fff;
    > span {
      color: #ddd20c;
    }
    transform: translate(-50%, -50%);
  }
}
.top {
  width: 426px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 200px 200px;
  grid-template-rows: 100px 100px;
  gap: 10px 30px;
  position: relative;
  z-index: 9999;
  > div {
    position: relative;
    background: url(/static/img/border.png);
    background-repeat: no-repeat;
    > div {
      display: flex;
      justify-content: space-around;
      position: absolute;
      left: 50%;
      top: 44%;
      transform: translate(-50%, -50%);
      width: 100%;
    }
  }
  font-family: DS-DIGIB;

  .count {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > span {
      &:nth-child(1) {
        margin-bottom: 6px;
        font-size: 32px;
        font-weight: bold;
      }
      &:nth-child(2) {
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .count-1 {
    color: #ddd20c;
  }
  .count-2 {
    color: #e10e0e;
  }
  .count-3 {
    color: #ddd20c;
  }
  .count-4 {
    color: #07e09b;
  }
}
.map-container {
  .map {
    height: 762px;
    width: 767px;
    margin: 50px 0;
  }
  .floor {
    display: flex;
    justify-content: space-between;
  }
  .left,
  .right {
    bottom: 0;
    display: inline-block;
    background: url(/static/img/list.png);
    background-repeat: no-repeat;
    background-size: 100% 550px;
    width: 401px;
    height: 550px;
    position: relative;
    z-index: 9999;
    .title {
      position: absolute;
      top: -55px;
      left: 4px;
      span {
        position: absolute;
        left: 30px;
        top: 13px;
        color: #05c4cc;
        font-weight: bold;
      }
    }
    .line {
      height: 1px;
      background-color: #00756f;
      width: 96%;
      margin: 0 auto;
    }
  }

  .main-list {
    height: 550px;
    background-repeat: no-repeat;
    box-sizing: border-box;
    .main-list--head {
      position: relative;
      height: 50px;
      display: flex;
      align-items: center;
      padding-top: 8px;
      width: 90%;
      margin: 0 auto;
      overflow-x: scroll;
      .tab {
        box-sizing: border-box;
        white-space: nowrap;
        padding: 4px 10px;
        cursor: pointer;
        &:hover {
          color: #00c6cc;
        }
      }
      .active-tab {
        border: 1px #00c6cc solid;
        color: #00c6cc;
      }
      > img {
        width: 30px;
      }
      > span {
        font-size: 16px;
        margin-left: 20px;
        color: #fff;
        > span {
          color: #05dbe3;
        }
      }
    }
    .main-list-body {
      overflow: hidden;
      overflow-y: scroll;
      padding-top: 20px;
      box-sizing: border-box;
      height: calc(550px - 67px);
    }
  }

  .right {
    right: 40px;
    .main-list--head {
      padding-left: 15px;
    }
  }

  .dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 979px;
    height: 639px;
    z-index: 10001;
    padding: 20px;
    padding-top: 0;
    .title {
      text-align: center;
      height: 38px;
      line-height: 38px;
      color: #fff;
      margin-top: 0px;
    }
    .close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 40px;
      right: 60px;
      cursor: pointer;
      color: #fff;
      font-size: 30px;
    }

    transform: translate(-50%, -50%);
    background: url(/static/img/dialog.png);
    background-repeat: no-repeat;
    background-position: center center;
    padding: 0 20px;
  }
}
</style>
